import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-svg-groupe',
  templateUrl: './svg-groupe.component.html',
  styleUrls: ['./svg-groupe.component.css']
})
export class SvgGroupeComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
